import React from 'react';

const products = [
  {
    icon: '📊',
    name: 'Power BI',
    color: 'bg-yellow-400',
    desc: 'Enterprise-grade dashboards, semantic models, and embedded analytics that turn raw data into boardroom-ready insights.',
    features: ['Custom visuals & themes', 'Row-level security', 'Paginated reports', 'Real-time streaming'],
  },
  {
    icon: '📱',
    name: 'Power Apps',
    color: 'bg-purple-500',
    desc: 'Low-code custom business applications that replace paper forms and manual workflows — deployed in days, not months.',
    features: ['Canvas & model-driven apps', 'SharePoint & Dataverse integration', 'Mobile-first design', 'Custom connectors'],
  },
  {
    icon: '🔀',
    name: 'Power Automate',
    color: 'bg-blue-500',
    desc: 'Automate repetitive processes across 900+ connectors — from email approvals to cross-system data sync.',
    features: ['Cloud & desktop flows', 'AI Builder integration', 'Approval workflows', 'RPA & attended bots'],
  },
  {
    icon: '🤖',
    name: 'Copilot Studio',
    color: 'bg-teal-500',
    desc: 'Build intelligent AI-powered chatbots and virtual agents with Microsoft Copilot Studio and Generative AI.',
    features: ['No-code bot builder', 'GPT-4 integration', 'Omni-channel deployment', 'Analytics & telemetry'],
  },
];

const PowerPlatform = () => {
  return (
    <section id="power-platform" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-14">
          <span className="inline-block bg-purple-100 text-purple-700 text-sm font-semibold px-3 py-1 rounded-full mb-4">
            ⚡ Microsoft Power Platform
          </span>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Power Platform Consulting
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            Empower your teams with Microsoft's low-code platform. We design, build, and govern Power Platform solutions that scale across your entire organization.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {products.map((p, i) => (
            <div key={i} className="bg-gray-50 rounded-2xl p-7 border border-gray-100 hover:border-purple-200 hover:shadow-lg transition-all">
              <div className="flex items-center gap-3 mb-4">
                <div className={`${p.color} w-12 h-12 rounded-xl flex items-center justify-center text-2xl text-white shadow`}>
                  {p.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900">{p.name}</h3>
              </div>
              <p className="text-gray-500 mb-4 leading-relaxed">{p.desc}</p>
              <ul className="grid grid-cols-2 gap-1">
                {p.features.map((f, j) => (
                  <li key={j} className="text-gray-600 text-sm flex items-center gap-1">
                    <span className="text-purple-500">✔</span> {f}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="#contact"
            className="inline-block bg-gradient-to-r from-purple-600 to-indigo-600 text-white px-8 py-3 rounded-full font-semibold hover:opacity-90 transition-opacity"
          >
            Get a Power Platform Assessment
          </a>
        </div>
      </div>
    </section>
  );
};

export default PowerPlatform;
